<div class="help-contents-wrap">

  <a class="help-close-btn" (click)="onClose($event)"></a>

  <div class="help-head-box">

    <div class="head-txt-box">사 성 옥편 도움말</div>
  </div>



  <ol class="help-body-box numbered">

    <div class="help-img-box">
      <img src="../../../assets/img/word-help1.gif" alt="이미지">
    </div>

    <li class="help-number-box">
      일제시대에 사용을 하도록 한 '한자<span class="hanja-size">漢子</span>'를 원래 대로, '문자<span class="hanja-size">文字</span>'라고 칭합니다.
    </li>
    <li class="help-number-box">
      한 문자에 여러 글자가 적힌 것은 분 문자의 동자, 속자, 간자 등입니다.
    </li>
    <li class="help-number-box">
      <div class="help-saseung-box">
        <div class="header cell">한국어 성조</div>
        <div class="header cell">수자<span class="hanja-size">數字</span> 표지</div>
        <div class="header cell">색상 표지</div>
        <div class="header cell">기호 표지</div>

        <div class="cell"><span class="left">고 평성<span class="hanja-size">高平聲</span></span></div>
        <div class="cell"><div class="type-2 seungjo-5"></div></div>
        <div class="cell"><div class="type-3 seungjo-5"></div></div>
        <div class="cell"><div class="type-1 seungjo-5"></div></div>

        <div class="cell"><span class="left">미끄러지는 소리</span></div>
        <div class="cell"><div class="type-2 seungjo-4"></div></div>
        <div class="cell"><div class="type-3 seungjo-4"></div></div>
        <div class="cell"><div class="type-1 seungjo-4"></div></div>

        <div class="cell"><span class="left">거성<span class="hanja-size">去聲</span></span></div>
        <div class="cell"><div class="type-2 seungjo-3"></div></div>
        <div class="cell"><div class="type-3 seungjo-3"></div></div>
        <div class="cell"><div class="type-1 seungjo-3"></div></div>

        <div class="cell"><span class="left">상성<span class="hanja-size">上聲</span></span></div>
        <div class="cell"><div class="type-2 seungjo-2"></div></div>
        <div class="cell"><div class="type-3 seungjo-2"></div></div>
        <div class="cell"><div class="type-1 seungjo-2"></div></div>

        <div class="cell"><span class="left">저 평성<span class="hanja-size">低平聲</span></span></div>
        <div class="cell"><div class="type-2 seungjo-1"></div></div>
        <div class="cell"><div class="type-3 seungjo-1"></div></div>
        <div class="cell"><div class="type-1 seungjo-1"></div></div>
      </div>
    </li>

  </ol>

  <div class="help-foot-box">

    <!-- div class="foot-msg-box">문자文字위에 사 성을 표시 하시겠습니까?</div -->

    <div class="foot-menu-box">
      <a class="foot-menu-btn type-1"
         [routerLink]="['/board', BBS_CATEGORY.USAGE, SASEUNG_HELP_BBS_ID]">자세히 보기</a>
    </div>

  </div>

</div>
